import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonitoramentoRepasseTipoClienteMainComponent } from './monitoramento-repasse-tipo-cliente-main/monitoramento-repasse-tipo-cliente-main.component';
import { GlobalModule } from '../../../global/global.module';
import { ComponentsModule } from '../../../global/components/components.module';
import { ButtonModule, CardModule, SharedModule, TableModule } from 'primeng';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
  declarations: [MonitoramentoRepasseTipoClienteMainComponent],
  imports: [
    CommonModule, GlobalModule, ComponentsModule, ButtonModule, SharedModule, TableModule, MatButtonModule, CardModule,
  ],
})
export class MonitoramentoRepasseTipoClienteModule { }
